export const isCSSOrderableItem = (orderableItem) => {
	return orderableItem?.collectionPackSupplier === "CSS";
}